<template>
  <div class="c-agenda">
    <div class="agenda-row" v-for="list in scheduleList" :key="list.agendaId">
      <div class="agenda-date">
        {{ list.startTimeDate }}-{{ list.endTimeDate }}
      </div>
      <div class="agenda-info">
        {{ list.theme }}
      </div>
      <div class="agenda-user">
        <div v-for="(guest, i) in list.agendaGuest" :key="i">
          {{ guest.name }}
          <br v-if="guest.enterprise || guest.duty" />
          {{ guest.enterprise }} {{ guest.duty }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, cr } from "fire-wind-water";
import moment from "moment";
export default {
  name: "Schedule",
  data() {
    return {
      scheduleList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        //把嘉宾的数据 和日常的数据组合一下
        cr.each(data.agendaList, d => {
          d.endTimeDate = moment(d.endTime * 1000).format("HH:mm");
          d.startTimeDate = moment(d.startTime * 1000).format("HH:mm");
          cr.each(d.agendaGuest, n => {
            cr.each(data.guestList, list => {
              if (list.webinarGuestId == n.webinarGuestId) {
                n.duty = list.duty; //"这是职务"
                n.enterprise = list.enterprise; //"这是公司"
                n.department = list.department; //"这是部门"
              }
            });
          });
        });
        this.scheduleList = data.agendaList;
      });
    }
  }
};
</script>

<style scoped></style>
